<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-users"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- Card: Lista de Clientes -->
<div class="table-card">
  <div class="card-header">
    <div class="card-header-icon table-icon">
      <i class="pi pi-list"></i>
    </div>
    <span class="card-header-title">{{ texts.lista_de_clientes }}</span>
  </div>
  <div class="card-content">
    <!-- Barra de busca + Botao adicionar + Seletor de colunas -->
    <div class="search-bar">
      <p-iconField iconPosition="right" class="search-field">
        <p-inputIcon styleClass="pi pi-search" />
        <input pInputText type="text"
          [placeholder]="placeholders.pesquisar"
          [(ngModel)]="searchNome"
          (ngModelChange)="onSearchChange($event)" />
      </p-iconField>

      <button pButton routerLink="/adicionar-cliente"
        [label]="botoes.adicionar_cliente"
        icon="pi pi-plus-circle" class="btn-primary">
      </button>

      <app-column-selector
        [columns]="columns"
        [storageKey]="STORAGE_KEY"
        (columnsChange)="onColumnsChange($event)">
      </app-column-selector>
    </div>

    <!-- Tabela -->
    <p-table [value]="pessoas" [loading]="loading"
      (sortFunction)="customSort($event)" [customSort]="true"
      [tableStyle]="{ 'min-width': '60rem', 'margin-top': '16px' }">

      <ng-template pTemplate="header">
        <tr>
          <th [hidden]="!isColumnVisible('codigoPessoa')" pSortableColumn="codigoPessoa" style="width: 6rem">
            {{ labels.codigo_cliente }}<p-sortIcon [field]="'codigoPessoa'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('nome')" pSortableColumn="nome">
            {{ labels.nome }}<p-sortIcon [field]="'nome'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('fantasia')" pSortableColumn="fantasia">
            {{ labels.nome_fantasia }}<p-sortIcon [field]="'fantasia'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('telefone')" pSortableColumn="telefone">
            {{ labels.telefone }}<p-sortIcon [field]="'telefone'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('ci')" pSortableColumn="ci">
            {{ labels.ci }}<p-sortIcon [field]="'ci'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('ruc')" pSortableColumn="ruc">
            {{ labels.ruc }}<p-sortIcon [field]="'ruc'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('cidade')" pSortableColumn="cidade.nome">
            {{ labels.cidade }}<p-sortIcon [field]="'cidade.nome'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('criadoEm')" pSortableColumn="criadoEm">
            {{ labels.data_inclusao }}<p-sortIcon [field]="'criadoEm'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('acoes')" style="width: 10rem">{{ labels.acoes }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-pessoa>
        <tr>
          <td [hidden]="!isColumnVisible('codigoPessoa')">{{ pessoa.codigoPessoa }}</td>
          <td [hidden]="!isColumnVisible('nome')">{{ pessoa.nome }}</td>
          <td [hidden]="!isColumnVisible('fantasia')">{{ pessoa.fantasia }}</td>
          <td [hidden]="!isColumnVisible('telefone')">{{ pessoa | formatPhone }}</td>
          <td [hidden]="!isColumnVisible('ci')">{{ pessoa.ci }}</td>
          <td [hidden]="!isColumnVisible('ruc')">{{ pessoa.ruc }}</td>
          <td [hidden]="!isColumnVisible('cidade')">{{ pessoa.cidade?.nome }}</td>
          <td [hidden]="!isColumnVisible('criadoEm')">{{ formatarDataEHora(pessoa.criadoEm) }}</td>
          <td [hidden]="!isColumnVisible('acoes')" class="actions">
            <button pButton icon="pi pi-eye"
              class="p-button-text p-button-rounded p-button-sm"
              [pTooltip]="tooltips.visualizar" tooltipPosition="top"
              (click)="viewCliente(pessoa.id)">
            </button>
            <button pButton icon="pi pi-pencil"
              class="p-button-text p-button-rounded p-button-sm"
              [pTooltip]="tooltips.editar" tooltipPosition="top"
              (click)="editarCliente(pessoa.id)">
            </button>
            <button pButton icon="pi pi-trash"
              class="p-button-text p-button-rounded p-button-sm p-button-danger"
              [pTooltip]="tooltips.excluir" tooltipPosition="top"
              (click)="deletarCliente(pessoa.id)">
            </button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex flex-column align-items-center">
              <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
              <div class="text-gray-500 text-lg">{{ texts.nenhum_cliente }}</div>
              <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
              <span class="ml-3">{{ texts.carregando }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao -->
    <div class="pagination-container">
      <div>
        <p-paginator (onPageChange)="onPageChange3($any($event))"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} de {totalRecords}"
          [first]="first3" [rows]="rows3"
          [totalRecords]="totalRecords"
          [showFirstLastIcon]="true">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [(ngModel)]="rows3"
          (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
        </p-dropdown>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>

<!-- Modal de Confirmacao de Exclusao (Wave Design) -->
<p-dialog [(visible)]="deleteDialogVisible" [showHeader]="false" [modal]="true"
  [closable]="false" [draggable]="false" styleClass="dialog-wave-redesign" [style]="{ width: '30rem' }">
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary" (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash" (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>
